import { render, staticRenderFns } from "./VideoDevice.vue?vue&type=template&id=dc65d0e6&scoped=true&"
import script from "./VideoDevice.vue?vue&type=script&lang=js&"
export * from "./VideoDevice.vue?vue&type=script&lang=js&"
import style0 from "./VideoDevice.vue?vue&type=style&index=0&id=dc65d0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc65d0e6",
  null
  
)

export default component.exports